<template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>STORES</h2>
				</div>
				<v-btn @click.prevent="fncBranchAdd" class="elevation-5" color="info"><i class="material-icons">add</i>Create Store</v-btn>
				<v-btn @click.prevent="fncReloadBranches" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {
			}
		},
		methods: {
			fncBranchAdd() {
              this.$store.dispatch('fncPopulateUserRegions');
              this.$store.commit('setBranchLogo', '');
				var modalDetails = { title: 'Add Store', component: 'modal-branch-add', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
          fncReloadDepartments() {
            this.$store.commit('fncEmptyBranches');
            this.$store.dispatch({
              type: 'fncPopulateBranches',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([
				'objAuthorize'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
